<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Ator
        </h2>

        <v-row>
          <v-col>
            <combobox-membros-by-municipio
              :municipio-id="payload.municipioId"
              :filter="atores"
              @onChange="onMembrosChange"
              :defaultValue="atores.defaultMembro"
            ></combobox-membros-by-municipio>
          </v-col>
        </v-row>

        <v-text-field
          label="Nome"
          name="nome"
          type="text"
          v-model="atores.nome"
          required
          :rules="rules"
          :disabled="!!this.atores.membroId"
          background-color="white"
        />

        <v-text-field
          label="Instituição"
          name="instituicao"
          type="text"
          v-model="atores.instituicao"
          required
          :rules="rules"
          background-color="white"
        />
        <v-row>
          <v-col>
            <v-select
              v-model="atores.grauInfluencia"
              :items="[1, 2, 3, 4, 5]"
              :rules="rules"
              label="Grau de Influência"
              placeholder="Grau de Influência"
            />
          </v-col>
          <v-col>
            <v-select
              v-model="atores.grauImpacto"
              item-text="nomeRegiao"
              :items="[1, 2, 3, 4, 5]"
              label="Grau de Impacto"
              :rules="rules"
              placeholder="Grau de Impacto"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Cargo/Função"
              name="cargofuncao"
              type="text"
              v-model="atores.cargoFuncao"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Telefone"
              name="telefone"
              type="text"
              v-mask="['(##) ####-####', '(##) #####-####']"
              v-model="atores.telefone"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="E-mail"
              name="email"
              type="text"
              v-model="atores.email"
              required
              :rules="emailRules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { atoresApi } from "@/apis";
import ComboboxMembrosByMunicipio from "../../../components/combobox/membros/ComboboxMembrosByMunicipio.vue";
export default {
  components: {
    AppCityHeader,
    ComboboxMembrosByMunicipio,
  },
  data() {
    return {
      atores: { membroId: 0 },
      payload: {
        municipioId: this.$route.params.id,
      },
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      atoresApi
        .find(this.tabId)
        .then(({ data }) => {
          this.atores = data;
          (this.atores.defaultMembro = this.atores.membroId),
            this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Ator");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    onMembrosChange() {
      if (this.atores.membro) {
        this.atores = {
          ...this.atores,
          nome: this.atores.membro.nome,
          telefone: this.atores.membro.telefone,
          email: this.atores.membro.email,
          cargoFuncao: this.atores.membro.cargo,
          membroId: this.atores.membro.membroId || 0,
        };
      } else {
        if (this.tabId == 0) {
          this.atores = { membroId: 0 };
        } else {
          this.atores.membroId = 0;
        }
      }
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;
      this.atores.municipioId = this.payload.municipioId;

      if (this.tabId > 0) {
        atoresApi
          .updateAtor(this.atores)
          .then(() => {
            this.$notification.success("Ator editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            if (err.response && err.response.data.message) {
              this.$notification.error("Membro já cadastrado!");
            } else {
              this.$notification.error("Erro ao criar Ator");
              console.log("Erro no submit ", err);
            }
          });
      } else {
        atoresApi
          .createAtor(this.atores)
          .then(() => {
            this.$notification.success("Ator criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            if (err.response && err.response.data.message) {
              this.$notification.error("Membro já cadastrado!");
            } else {
              this.$notification.error("Erro ao criar Ator");
              console.log("Erro no submit ", err);
            }
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
